import Vue from 'vue';
import VueRouter from 'vue-router';
import { auth } from '../firebase';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import LoginDisabled from './views/LoginDisabled.vue';
//import Test from './views/Test.vue';
import Test from './views/TestV2.vue';
import Start from './views/Start.vue';
import Finish from './views/Finish.vue';
import PasswordReset from './views/PasswordReset.vue';
import Signup from './views/Signup.vue';
import ProgressBar from './components/ProgressBar.vue';

window.popStateDetected = false;
window.addEventListener('popstate', () => {
    window.popStateDetected = true
});

Vue.use(VueRouter)

export const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/test',
            name: 'Test',
            component: Test,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/testv2',
            name: 'TestV2',
            component: Test,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'LoginDisabled',
            component: LoginDisabled
        },
        {
            path: '/signup',
            name: 'Signup',
            component: Signup
        },
        {
            path: '/auth/passwordreset',
            name: 'PasswordReset',
            component: PasswordReset
        },
        {
            path: '/start',
            name: 'start',
            component: Start,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/finish',
            name: 'Finish',
            component: Finish,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/progressbar',
            name: 'ProgressBar',
            component: ProgressBar
        },
        {
            path: '/compliance',
            redirect: '/?t=compliance'
        },
        {
            path: '/*',
            redirect: '/'
        }
    ]
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth);

    if (requiresAuth && !auth.currentUser) {
        const query = to.redirectedFrom !== '/compliance' ? {} : {t: 'compliance'}
        next({ name: 'LoginDisabled', query });
    } else {
        next();
        /*
        if (from.path === '/testv2' && to.path === '/') {
            next(false);
        } else {
            next();
        }
        */

    } 
})

